import { CredentialResponse, GoogleLogin } from '@react-oauth/google'
import { useQueryClient } from '@tanstack/react-query'
import Icon from '@/components/Icon'
import { googleLogin } from '@/network/api/login'
import { Footer, LeftSection, Logo, PageWrapper, PayWrapper, RightSection, Subtitle, Title } from './styles'

const Login = () => {
  const queryClient = useQueryClient()
  const navigate = useNavigate()
  const { isLoggedIn, userInfo } = useUserStore()
  const [isLoading, setIsLoading] = useState(false)

  const googleLoginHandler = async (credentialResponse: CredentialResponse) => {
    try {
      setIsLoading(true)
      if (credentialResponse?.credential) {
        await googleLogin({ code: credentialResponse?.credential })
        // 登录成功后刷新用户数据
        const res = await queryClient.fetchQuery({ queryKey: ['user'] })
        //@ts-ignore
        navigate(`/home/${res.user.email.replace('@gmail.com', '')}`)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <PageWrapper>
      <PayWrapper>
        <LeftSection>
          <Icon type="logoRect" />
          <Title>Welcome to Creavo</Title>
          <Subtitle>
            Sign up to get <Icon type="lightning" />
            <span>40 free</span> Credits
          </Subtitle>
          {isLoggedIn ? (
            <div>
              <p>You are already logged in</p>{' '}
              <button
                onClick={() => navigate(`/home/${userInfo?.user?.email?.replace('@gmail.com', '')}`)}
                style={{
                  padding: '10px 20px',
                  borderRadius: '20px',
                  cursor: 'pointer',
                }}
              >
                Go to My Visuals
              </button>
            </div>
          ) : (
            <>
              
              {isLoading ? <div>Loging...</div> : 
              <GoogleLogin
                shape="pill"
                auto_select={true}
                onSuccess={googleLoginHandler}
                onError={() => {
                  console.log('Login Failed')
                  setIsLoading(false)
                }}
              />}
            </>
          )}
        </LeftSection>

        <RightSection></RightSection>
      </PayWrapper>

      <Footer>
        By continuing, you agree to the <a href="/terms">Terms of Use</a> and <a href="/privacy">Privacy Policy</a>
      </Footer>
    </PageWrapper>
  )
}

export default Login
